import { AffiliateTypesEnum } from "@/common/types/affiliate";

export const technical = {
    types: {
        [AffiliateTypesEnum.ADMIN]: "Administrador",
        [AffiliateTypesEnum.MANAGER]: "Gestor",
        [AffiliateTypesEnum.TECHNICAL]: "Técnico",
        [AffiliateTypesEnum.ASSISTANT]: "Assistente",
    },
    labels: {
        technical: "Técnico",
    },
    texts: {
        add_technical: "Adicionar Técnico",
        technical_limit: "Você já atingiu o limite de técnicos!",
    },
};
